import {
  getCurrentSchoolYearStartYear,
  getDefaultSchoolClassesFilters,
} from "../../components/common/schoolYear";

export default {
  teachers: [],
  clients: [],
  people: [],
  products: [],
  enrollments: [],
  students: [],
  schoolClasses: [],
  classStudents: [],
  clientLedger: [],
  lessonRegister: [],
  lessonRegisterReads: {},
  books: [],
  user: { id: "guest", role: "GUEST" },
  apiCallsInProgress: 0,
  settings: {
    showArchivedClients: false,
    activeSchoolYearStartYear: getCurrentSchoolYearStartYear(),
    schoolClassesFilters: getDefaultSchoolClassesFilters(),
  },
};
